import { useRef } from 'react';
import styled from 'styled-components';
import WeatherForecastLineChart, {
    initialDayWidth,
} from './WeatherForecastLineChart';
import useDimensions from '../../../helpers/useDimensions';

const ChartContainer = styled.div`
    height: ${({ $height }) => $height || 200}px;
`;

const WeatherForecastPanel = ({ forecast = {} }) => {
    const { date = [], Tmin, Tmax, Glob, Wind, Image } = forecast;
    const chartContainerRef = useRef();
    const [width] = useDimensions(chartContainerRef);

    let scaleFactor = 1;
    if (date.length * initialDayWidth > width) {
        scaleFactor = width / (date.length * initialDayWidth);
    }

    const nivoData = [
        {
            id: 'max temp',
            data: date.map((d, i) => {
                return {
                    x: d,
                    y: Tmax[i],
                    wind: Wind[i],
                    glob: Glob[i],
                    img: Image[i],
                };
            }),
            color: '#FF0000',
            scaleFactor,
        },
        {
            id: 'min temp',
            data: date.map((d, i) => {
                return {
                    x: d,
                    y: Tmin[i],
                };
            }),
            color: '#0000FF',
            scaleFactor,
        },
    ];

    return (
        <ChartContainer ref={chartContainerRef} $height={200 * scaleFactor}>
            <WeatherForecastLineChart
                data={nivoData}
                scaleFactor={scaleFactor}
            />
        </ChartContainer>
    );
};

export default WeatherForecastPanel;
